module.exports = __webpack_public_path__ + "img/111.0bc6c13f.png";